import * as React from 'react';
import { createSvgIcon } from "..";

export const Close = createSvgIcon(<path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" strokeWidth="2" d="M5 5l14 14M19 5L5 19" />);
